import { TableToolbar } from '@wix/design-system';
import React from 'react';
import { st, classes } from './ToolbarItem.st.css.js';

export function ToolbarItem({ children }: { children: React.ReactNode }) {
  return (
    <TableToolbar.Item className={st(classes.root)}>
      {children}
    </TableToolbar.Item>
  );
}
